"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.settings.chunkSize.label': 'Dimensione Frammento',
    'rag.settings.chunkSize.description': 'Dimensione dei frammenti di testo per l\'indicizzazione (100-2000 caratteri)',
    'rag.settings.chunkOverlap.label': 'Sovrapposizione Frammenti',
    'rag.settings.chunkOverlap.description': 'Sovrapposizione tra frammenti per preservare il contesto (0-500 caratteri)',
    'rag.settings.similarityThreshold.label': 'Soglia di Somiglianza',
    'rag.settings.similarityThreshold.description': 'Punteggio minimo di somiglianza per i risultati di ricerca (0.1-1.0)',
    'rag.settings.defaultMaxResults.label': 'Risultati Max Predefiniti',
    'rag.settings.defaultMaxResults.description': 'Numero predefinito di risultati di ricerca da restituire (1-20)',
    'rag.settings.maxResults.label': 'Risultati Massimi',
    'rag.settings.maxResults.description': 'Numero massimo di risultati di ricerca consentiti (1-20)',
    'rag.settings.separators.label': 'Separatori di Testo',
    'rag.settings.separators.description': 'Caratteri usati per dividere il testo in frammenti (separati da virgole)',
    'rag.settings.separators.placeholder': 'Inserire separatori separati da virgole',
    'rag.settings.separators.add': 'Aggiungi Separatore',
    'rag.settings.resetToDefaults.label': 'Ripristina Predefiniti',
    'rag.settings.resetToDefaults.tooltip': 'Ripristina le impostazioni RAG ai valori predefiniti',
};
